import { useCallback } from "react"
import { ConnectionHandler } from "react-relay"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { chCreateRecommendedMedicationMutation } from "@/modules/patients/detail/recommended-medications/ch/__generated__/chCreateRecommendedMedicationMutation.graphql"
import { chCreateRecommendedMedicationMutation as chCreateRecommendedMedication } from "@/modules/patients/detail/recommended-medications/ch/chCreateRecommendedMedicationMutation"
import { deCreateRecommendedMedicationMutation } from "@/modules/patients/detail/recommended-medications/de/__generated__/deCreateRecommendedMedicationMutation.graphql"
import { deCreateRecommendedMedicationMutation as deCreateRecommendedMedication } from "@/modules/patients/detail/recommended-medications/de/deCreateRecommendedMedicationMutation"
import { Country } from "@/types/__generated__/union-types"

type MutationParams = {
  medicationId: string
  patientId: string
  progressNoteId: string
  onCompleted?: () => void
  onError?: (error: Error | string | undefined) => void
}

export const useCreateRecommendedMedication = (country?: Country) => {
  const mutation = country === "CH" ? chCreateRecommendedMedication : deCreateRecommendedMedication

  const [commit] = useMutationWithErrorToast<
    chCreateRecommendedMedicationMutation | deCreateRecommendedMedicationMutation
  >(mutation)

  return useCallback(
    (params: MutationParams) => {
      const { medicationId, patientId, progressNoteId, onCompleted, onError } = params
      const connection = ConnectionHandler.getConnectionID(
        progressNoteId,
        country === "CH"
          ? "ProgressNoteConnection_ch_recommendedMedications"
          : "ProgressNoteConnection_de_recommendedMedications",
      )
      commit({
        variables: { input: { medicationId, patientId, progressNoteId }, connections: [connection] },
        onCompleted,
        onError,
      })
    },
    [commit, country],
  )
}
